import { Badge, Tabs } from '@mantine/core';
import type { JSX, ReactNode } from 'react';
import classes from './PageTabs.module.css';

export interface PageTabsItem {
  id: string;
  label: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  badgeCount?: number;
}

interface PageTabsProps {
  tabs: PageTabsItem[];
  value: string;
  onChange: (value: string) => void;
}

export function PageTabs({ tabs, value, onChange }: PageTabsProps): JSX.Element {
  return (
    <Tabs
      value={value}
      onChange={(v) => {
        if (v) {
          onChange(v);
        }
      }}
      variant="pills"
      radius="md"
      classNames={{ root: classes.nav }}
    >
      <Tabs.List className={classes.list}>
        {tabs.map((t) => (
          <Tabs.Tab
            key={t.id}
            value={t.id}
            disabled={t.disabled}
            leftSection={t.icon}
            rightSection={
              t.badgeCount && t.badgeCount > 0 ? (
                <Badge color="red" circle size="sm" aria-label={`${t.id} has ${t.badgeCount} items`}>
                  {t.badgeCount}
                </Badge>
              ) : undefined
            }
          >
            {t.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
}
